import { Link } from "react-router-dom";

export default function MentionsLegales() {
    return (
        <div className="max-w-3xl mx-auto px-6 sm:px-10 py-20" data-testid="mentions-legales-page">
            <p className="section-tag">informations légales</p>
            <h1 className="font-display text-5xl md:text-6xl text-[#2A1408] leading-[0.9] mt-1">
                Mentions légales.
            </h1>

            <div className="mt-10 space-y-8 text-[#3D1F0F] leading-relaxed">
                <section>
                    <h2 className="font-display text-2xl text-[#2A1408] mb-2">
                        Éditeur du site
                    </h2>
                    <p>
                        <strong>Le Comptoir du Cookie</strong>
                        <br />
                        Adresse : à compléter
                        <br />
                        Téléphone : à compléter
                        <br />
                        Email : à compléter
                        <br />
                        SIRET : à compléter
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-2xl text-[#2A1408] mb-2">
                        Directeur de la publication
                    </h2>
                    <p>Le représentant légal du Comptoir du Cookie.</p>
                </section>

                <section>
                    <h2 className="font-display text-2xl text-[#2A1408] mb-2">
                        Hébergement
                    </h2>
                    <p>
                        Informations relatives à l'hébergement disponibles sur simple
                        demande via le formulaire de la page Contact.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-2xl text-[#2A1408] mb-2">
                        Propriété intellectuelle
                    </h2>
                    <p>
                        L'ensemble des contenus du site (textes, photos, logos, créations
                        graphiques) est la propriété exclusive du Comptoir du Cookie.
                        Toute reproduction sans autorisation préalable est interdite.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-2xl text-[#2A1408] mb-2">
                        Conception & réalisation
                    </h2>
                    <p>
                        Site conçu et réalisé par{" "}
                        <a
                            href="https://axeris-labs.fr"
                            target="_blank"
                            rel="noreferrer"
                            className="underline decoration-2 decoration-[#D6552C] underline-offset-4 hover:text-[#D6552C]"
                        >
                            Axeris Labs
                        </a>
                        .
                    </p>
                </section>

                <p className="pt-6">
                    <Link
                        to="/"
                        className="font-handwritten text-2xl text-[#B07B66] hover:text-[#D6552C]"
                    >
                        ← retour à l'accueil
                    </Link>
                </p>
            </div>
        </div>
    );
}
